@let info = supportInfo();

<div class="flex">
	@if (info?.label; as label) {
		<p class="min-w-5 overflow-hidden text-ellipsis shrink-5" [pTooltip]="label">{{ label }}:</p>
		@if (info?.email; as email) {
			<span class="flex items-center min-w-14 shrink-10" [pTooltip]="email">
				<i aria-hidden="true" class="fa fa-envelope ml-4 mr-1"></i>
				<a class="overflow-hidden text-ellipsis" href="{{ 'mailto:' + email }}">{{ email }}</a>
			</span>
		}
		@if (info?.phoneNumber; as phoneNumber) {
			<span class="flex items-center shrink-0 min-w-10" [pTooltip]="phoneNumber | phone"
				><i aria-hidden="true" class="fa fa-phone ml-4 mr-1"></i>
				<p>{{ phoneNumber | phone }}</p></span
			>
		}
		@if (info?.urlLabel && info?.url; as url) {
			<span class="flex items-center min-w-14 shrink-20" [pTooltip]="info?.urlLabel">
				<i aria-hidden="true" class="fa fa-globe ml-4 mr-1"></i>
				<a class="overflow-hidden text-ellipsis" target="_blank" [href]="url">{{ info?.urlLabel }}</a>
			</span>
		}
	}
</div>
